import axios from 'axios'
import api from '@/api/api'
import state from '@/store/module_principal/state'

export default {
  buscarPlacaAlerta (codUsuario, cidade, placa) {
    var info = { 
      placa: placa,
      cidade: cidade,
      codigoUsuario: codUsuario,
    }
    var token = { token: api.aesEncrypt(JSON.stringify(info)) }
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/buscarPlacaAlerta', token, {
    //return axios.post("http://192.168.0.24:5004/buscarPlacaAlerta", token, {
      headers: {
          "content-type": "application/x-www-form-urlencoded"
      }
    }).then(result => result.data)
  },
  cadastrarAlerta (usuario, cidade, alerta) {
    var info = { 
      usuario: usuario,
      cidade: cidade,
      placa: alerta.placa,
      cor: alerta.cor,
      modelo: alerta.modelo,
      dataInicial: alerta.dataInicial,
      dataFinal: alerta.dataFinal,
      idTelegram: alerta.idTelegram,
      tipoAlerta: alerta.tipoAlerta,
      recomendacao: alerta.recomendacao,
      detalhe: alerta.detalhe   
    }
    var token = { token: api.aesEncrypt(JSON.stringify(info)) }
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/cadastrarAlerta', token, {
    //return axios.post("http://192.168.0.24:5004/cadastrarAlerta", token, {
    
        headers: {
            "content-type": "application/x-www-form-urlencoded"
        }
    }).then(result => result.data)
  },
  alterarAlerta (codOcorrencia, usuario, cidade, alerta) {
    var info = {
      codOcorrencia: codOcorrencia, 
      usuario: usuario,
      cidade: cidade,
      placa: alerta.placa,
      cor: alerta.cor,
      modelo: alerta.modelo,
      dataInicial: alerta.dataInicial,
      dataFinal: alerta.dataFinal,
      idTelegram: alerta.idTelegram,
      tipoAlerta: alerta.tipoAlerta,
      recomendacao: alerta.recomendacao,
      detalhe: alerta.detalhe,
    }
    var token = { token: api.aesEncrypt(JSON.stringify(info)) }
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/alterarAlerta', token, {
    //return axios.post("http://192.168.0.24:5004/alterarAlerta", token, {
    
        headers: {
            "content-type": "application/x-www-form-urlencoded"
        }
    }).then(result => result.data)
  },
  deletarAlerta (codigoUsuario, cidade, codigoAlerta) {
    var info = { 
      usuario: codigoUsuario,
      cidade: cidade,
      codigoAlerta: codigoAlerta
    }
    var token = { token: api.aesEncrypt(JSON.stringify(info)) }
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/deletarAlerta', token, {
    //return axios.post("http://192.168.0.24:5004/deletarAlerta", token, {
    
        headers: {
            "content-type": "application/x-www-form-urlencoded"
        }
    }).then(result => result.data)
  },
  buscarAlertas (codigoUsuario, cidade) {
    var info = { 
      cidade: cidade,
      codigoUsuario: codigoUsuario,
    }
    var token = { token: api.aesEncrypt(JSON.stringify(info)) }
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/buscarAlertas', token, {
    //return axios.post("http://192.168.0.24:5004/buscarAlertas", token, {
      headers: {
          "content-type": "application/x-www-form-urlencoded"
      }
    }).then(result => result.data)
  },
}